import React, { forwardRef } from 'react';

import { bemCssModules, getTestId } from '@utils';

import style from './Tooltip.scss';

const cn = bemCssModules(style, 'Tooltip');
const ti = getTestId('Tooltip');

export type TTooltip = {
  className?: string;
  isOpen?: boolean;
  children?: React.ReactNode;
};

export const Tooltip = forwardRef<HTMLDivElement, TTooltip>(
  ({ className, isOpen, children }, ref) => (
    <div className={cn({ hidden: !isOpen }, [className])} ref={ref} data-testid={ti()}>
      {children}
    </div>
  )
);

export default Tooltip;
